import styled from "styled-components";
import { colors } from "../../../../utils/colors";

export const StyledLobby = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;

  .subtitle {
    margin-top: 8px;
    color: ${colors.textSecondary};
  }

  .link-section {
    display: flex;
    flex-wrap: wrap;

    .link {
      width: 100%;
    }
    .link-with-btn {
      width: 65%;
    }
    .button {
      width: 35%;
    }

    @media only screen and (max-width: 600px) {
      .link, .button {
        width: 100%;
      }
    }
  }

  .users-list-wrapper {
    align-self: center;
    margin-top: 32px;
    color: ${colors.textSecondary};
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .users-list {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
    }
  }
`;